import styled from 'styled-components';

const StyledHeaderWrapper = styled.header`
  margin: 0 auto;
  padding: 0 1rem;

  @media ${(props) => props.theme.breakpoints.lg} {
    margin: 0 auto;
    max-width: ${(props) => props.theme.maxHeaderWidth};
    padding: 0;
  }
`;

const StyledContentWrapper = styled.div`
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;

  @media ${(props) => props.theme.breakpoints.lg} {
    max-width: ${(props) => props.theme.maxContentWidth};
  }
`;

type ArticleProps = {
  children?: React.ReactNode;
};

const Article = ({ children }: ArticleProps) => {
  return <article>{children}</article>;
};

const HeaderWrapper = ({ children }) => {
  return <StyledHeaderWrapper>{children}</StyledHeaderWrapper>;
};

const ContentWrapper = ({ children }) => {
  return <StyledContentWrapper>{children}</StyledContentWrapper>;
};

Article.HeaderWrapper = HeaderWrapper;
Article.ContentWrapper = ContentWrapper;

export default Article;
